import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class MotivoIndisponibilidadeService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getMotivosIndisponibilidade(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/motivosindisponibilidade' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getMotivoIndisponibilidade(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/motivosindisponibilidade/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaMotivoIndisponibilidade(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/motivosindisponibilidade', {
				motivo_indisponibilidade_nome: data.motivo_indisponibilidade_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaMotivoIndisponibilidade(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/motivosindisponibilidade/' + data.motivo_indisponibilidade_id, {
				motivo_indisponibilidade_nome: data.motivo_indisponibilidade_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaMotivoIndisponibilidade(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/motivosindisponibilidade/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
